<template>
  <div class="pd20x flex1">
    <div class="contentBox h100pct ofA">
      <div class="filter" style="padding:10px 20px; display: flex; gap: 15px; align-items: center;">
        <label>状态筛选：</label>
        <a-radio-group v-model="filter.status" @change="searchData" button-style="solid">
          <a-radio-button :value="-1">全部</a-radio-button>
          <a-radio-button :value="0">待审核</a-radio-button>
          <a-radio-button :value="1">已打款/结案</a-radio-button>
          <a-radio-button :value="2">已拒绝/退回</a-radio-button>
        </a-radio-group>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="changePage"
      >
        <template slot="money" slot-scope="text">
          <span style="font-weight: bold; color: #ff5252; font-size: 15px;">￥{{ text.toFixed(2) }}</span>
        </template>
        <template slot="payment_type" slot-scope="text">
          <a-tag v-if="text === 1" color="green">微信钱包</a-tag>
          <a-tag v-else-if="text === 2" color="blue">支付宝</a-tag>
          <a-tag v-else-if="text === 3" color="orange">银行卡</a-tag>
        </template>
        <template slot="account_info" slot-scope="text">
          <div style="font-size: 12px; max-width: 250px; word-break: break-all;">
            {{ text }}
          </div>
        </template>
        <template slot="receipt_code" slot-scope="text">
          <div v-if="text">
            <a-avatar
              shape="square"
              :size="40"
              :src="text"
              style="cursor: pointer; border: 1px solid #e8e8e8;"
              @click="previewCode(text)"
            />
          </div>
          <span v-else style="color: #bfbfbf;">—</span>
        </template>
        <template slot="status" slot-scope="text">
          <a-badge v-if="text === 0" status="warning" text="待审核" />
          <a-badge v-else-if="text === 1" status="success" text="已打款" />
          <a-badge v-else-if="text === 2" status="error" text="已拒绝退回" />
        </template>
        <template slot="operation" slot-scope="text, record">
          <div v-if="record.status === 0">
            <a-popconfirm
              title="确定线下已完成转账打款，并将其标记为已同意结案吗？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="handlePass(record.id)"
            >
              <a href="javascript:;" style="margin-right: 15px; color: #52c41a;">打款通过</a>
            </a-popconfirm>
            <a href="javascript:;" @click="showRejectModal(record)" style="color: #ff4d4f;">拒绝退回</a>
          </div>
          <span v-else>-</span>
        </template>
      </a-table>
    </div>

    <!-- 拒绝提现说明弹窗 -->
    <a-modal
      title="提现申请拒绝退回"
      :visible="rejectVisible"
      :confirm-loading="rejectLoading"
      @ok="handleReject"
      @cancel="rejectVisible = false"
      okText="确定拒绝"
      cancelText="取消"
    >
      <div style="margin-bottom: 10px;"><strong>提现单号:</strong> {{ activeRecord ? activeRecord.withdraw_no : '' }}</div>
      <div style="margin-bottom: 15px;"><strong>提现金额:</strong> <span style="color:red; font-weight:bold;">￥{{ activeRecord ? activeRecord.money.toFixed(2) : '0.00' }}</span></div>
      <div style="margin-bottom: 8px;"><strong>请输入拒绝原因 (该原因将反馈给商户且资金会自动退回其余额):</strong></div>
      <a-textarea v-model="rejectRemark" placeholder="如：打款账户名不符/账户被限制，请重新绑定" :rows="3" />
    </a-modal>

    <!-- 收款码大图预览弹窗 -->
    <a-modal
      title="收款码预览"
      :visible="previewVisible"
      :footer="null"
      @cancel="previewVisible = false"
      width="400px"
      centered
    >
      <div style="text-align: center; padding: 10px;">
        <img :src="previewImage" style="max-width: 100%; max-height: 500px; object-fit: contain; border-radius: 4px;" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as http from '@/libs/examapi'

const columns = [
  {
    title: '提现单号',
    dataIndex: 'withdraw_no',
    align: 'center',
    width: 160
  },
  {
    title: '申请商家',
    dataIndex: 'tenant_name',
    align: 'center',
    width: 120
  },
  {
    title: '申请金额',
    dataIndex: 'money',
    scopedSlots: { customRender: 'money' },
    align: 'center',
    width: 100
  },
  {
    title: '打款渠道',
    dataIndex: 'payment_type',
    scopedSlots: { customRender: 'payment_type' },
    align: 'center',
    width: 100
  },
  {
    title: '收款人账号及明细',
    dataIndex: 'account_info',
    scopedSlots: { customRender: 'account_info' },
    align: 'left'
  },
  {
    title: '收款码',
    dataIndex: 'receipt_code',
    scopedSlots: { customRender: 'receipt_code' },
    align: 'center',
    width: 100
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
    align: 'center',
    width: 100
  },
  {
    title: '申请时间',
    dataIndex: 'create_time',
    align: 'center',
    width: 150
  },
  {
    title: '打款/拒绝备注',
    dataIndex: 'remark',
    align: 'center',
    width: 150
  },
  {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'operation' },
    align: 'center',
    width: 140
  }
]

export default {
  name: 'WithdrawList',
  data () {
    return {
      columns,
      data: [],
      loading: false,
      filter: {
        status: -1
      },
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      rejectVisible: false,
      rejectLoading: false,
      rejectRemark: '',
      activeRecord: null,
      previewVisible: false,
      previewImage: ''
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        status: this.filter.status
      }
      http.getWithdraws(params).then(res => {
        this.loading = false
        if (res && res.data) {
          this.data = res.data
          this.pagination.total = res.total
        } else {
          this.$message.error('拉取提现列表失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('获取列表异常')
      })
    },
    searchData () {
      this.pagination.current = 1
      this.getData()
    },
    changePage (pagination) {
      this.pagination.current = pagination.current
      this.getData()
    },
    handlePass (id) {
      http.auditWithdraw({ id, status: 1, remark: '打款成功已结案' }).then(res => {
        if (res !== undefined) {
          this.$message.success('已确认打款并通过')
          this.getData()
        }
      }).catch(() => {
        this.$message.error('审批操作失败')
      })
    },
    showRejectModal (record) {
      this.activeRecord = record
      this.rejectRemark = ''
      this.rejectVisible = true
    },
    handleReject () {
      if (!this.rejectRemark.trim()) {
        this.$message.warning('请输入拒绝退回的原因')
        return
      }
      this.rejectLoading = true
      http.auditWithdraw({
        id: this.activeRecord.id,
        status: 2,
        remark: this.rejectRemark
      }).then(res => {
        this.rejectLoading = false
        if (res !== undefined) {
          this.$message.success('已拒绝并退款回余额')
          this.rejectVisible = false
          this.getData()
        }
      }).catch(() => {
        this.rejectLoading = false
        this.$message.error('拒绝审批失败')
      })
    },
    previewCode (url) {
      this.previewImage = url
      this.previewVisible = true
    }
  }
}
</script>

<style scoped>
.pd20x {
  padding: 20px;
}
.flex1 {
  flex: 1;
}
.contentBox {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
.h100pct {
  height: 100%;
}
.ofA {
  overflow: auto;
}
.filter {
  border-bottom: 1px solid #f0f0f0;
}
</style>
